import request from 'utils/request'
import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instituteRequest'
import authRequest from 'utils/authRequest'
import adminRequest from 'utils/adminRequest'
import authRequested from './authRequested'

const initializeApp = token => {
  request.defaults.headers.common['Authorization'] = token
  corporateRequest.defaults.headers.common['Authorization'] = token
  studentRequest.defaults.headers.common['Authorization'] = token
  instituteRequest.defaults.headers.common['Authorization'] = token
  authRequest.defaults.headers.common['Authorization'] = token
  adminRequest.defaults.headers.common['Authorization'] = token
  authRequested.defaults.headers.common['Authorization'] = token
}

export default initializeApp
